import { Worksheet } from 'exceljs';
import { logger } from 'core/logger';
import { appInsights } from 'core/logger/ApplicationInsightsService';
import { SeverityLevel } from '@microsoft/applicationinsights-web';


export   const customizeHeader = (worksheet: Worksheet, reportHeaderTagLine?: string, headerTitleForSheet?: string) => {
    try {
      if (reportHeaderTagLine) {
        worksheet.mergeCells(1, 1, 1, 2);
        worksheet.mergeCells(1, 3, 1, 13);        
        worksheet.getRow(1).height = 55;
        worksheet.getRow(1).getCell(1).alignment = {
          vertical: 'middle',
          horizontal: 'center',
        };
        worksheet.getRow(1).getCell(3).font = {
          bold: true,
          size: 24,
        };
        worksheet.getRow(1).getCell(3).alignment = {
          vertical: 'middle',
          horizontal: 'left',
        };
        worksheet.getRow(1).getCell(3).value = headerTitleForSheet ?? 'Report';
      }
      // const bands = getBands(columns, columnBandsName); // TODO:
      // if (bands)
      //   bands?.forEach((element) => {
      //     const { start, end, title: bandTitle } = element;
      //     worksheet.mergeCells(3, start, 3, end);
      //     worksheet.getRow(3).getCell(start).font = { bold: true, size: 12 };
      //     worksheet.getRow(3).getCell(start).value = bandTitle;
      //   });
    } catch (error) {
      logger?.error(error);
      appInsights?.trackException({ error: new Error(`${error}`), severityLevel: SeverityLevel.Error });
    }
  };